<panel *ngIf="!loading">
  <div header>Thu chi cho dịch vụ trong {{configs.invoiceResolvableDays}} ngày trở lại</div>
  <div class="flex" right>
    <text-filter [target]="payments" [placeholder]="'Tìm kiếm'"></text-filter>
    <button class="bg-success std-margin-left" (click)="add('income')"><i class="fa fa-plus text-white"></i></button>
    <button class="bg-danger std-margin-left" (click)="add('expense')"><i class="fa fa-minus text-white"></i></button>
  </div>

  <table responsive class="data hover">
    <tr>
      <th priority="6" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top">Ngày</th>
      <th priority="3" class="text-top">Hạng mục</th>
      <th priority="2" class="text-top">Loại</th>
      <th priority="4" class="text-top">Lý do</th>
      <th priority="1" class="text-top text-right">Số tiền</th>
      <th priority="2" class="text-top" style="width: 0"></th>
    </tr>
    <tr *ngFor="let i of payments.pageMatches; index as ix">
      <td><small>{{ix + 1 + payments.pageIndex * payments.pageSize}}</small></td>
      <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td>
        <div class="uppercase text-warning bold">{{partner(i)}}</div>
        <small class="uppercase">{{group(i)}}</small>
      </td>
      <td class="uppercase" [ngClass]="{'text-success': type(i) == 'income', 'text-danger': type(i) == 'expense'}">{{(type(i) == 'income' ? 'thu' : 'chi') | lang}}</td>
      <td><elipsis>{{i.Notes}}</elipsis></td>
      <td [ngClass]="{'text-success': type(i) == 'income', 'text-danger': type(i) == 'expense'}">{{i.ReceiveAmount | number : '1.0-0' : 'en-US'}}<vnd></vnd></td>
      <td><i *ngIf="editable(i)" class="fa fa-edit text-primary pointer" (click)="open(i)"></i></td>
    </tr>
    <tr *ngIf="payments.pages.length > 1" class="footer">
      <td class="hidden"></td>
      <td [colSpan]="7" class="text-center"><pagination [target]="payments"></pagination></td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
